import React from "react"
import { Button, Table } from "react-bootstrap"
import { Formik, FieldArray } from "formik"
import _ from "lodash"

import SingleSelect from "./input/SingleSelect"
import HiddenInput from "./HiddenInput"

const filteredRecipientOptions = (recipients, proposals) =>
  _.reject(recipients, (o) => _.find(proposals, ["recipient.id", o.value]))

const newAppointment = ({ recipient }) => ({
  recipient,
})

const ProductProposalManagementForm = ({ product }): JSX.Element => (
  <Formik
    initialValues={{
      proposals: product.proposals,
      newRecipientId: null,
    }}
    onSubmit={() => undefined}
  >
    {({ values, setFieldValue }) => (
      <FieldArray
        name="proposals"
        render={(arrayHelpers) => (
          <>
            <Table>
              <thead>
                <tr>
                  <th>Recipient</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {_.isEmpty(values.proposals) && (
                  <tr>
                    <td>
                      No proposals currently loaded. Select a cruise line from the recipients below.
                    </td>
                  </tr>
                )}
                {values.proposals.map((proposal, index) => (
                  <tr key={proposal.recipient.id}>
                    <td className="text-nowrap align-middle">
                      <HiddenInput
                        name="onboarding_tour_marketplace_product_proposal_management_form[proposals][][recipient_id]"
                        value={proposal.recipient.id}
                      />
                      {proposal.recipient.name}
                    </td>
                    <td className="text-end">
                      <Button onClick={() => arrayHelpers.remove(index)} variant="danger">
                        <i className="fas fa-trash" />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <SingleSelect
              name="new_recipient"
              label=""
              placeholder="Available recipients"
              options={filteredRecipientOptions(product.availableRecipients, values.proposals)}
              onChange={(e) => {
                const recipientOption = _.find(product.availableRecipients, [
                  "value",
                  e.target.value,
                ])

                arrayHelpers.push(
                  newAppointment({
                    recipient: { id: recipientOption.value, name: recipientOption.label },
                  })
                )

                setFieldValue("newRecipientId", null)
              }}
              value={values.newRecipientId}
            />
          </>
        )}
      />
    )}
  </Formik>
)

export default ProductProposalManagementForm
